const initialState = {
    data: {
      landlord: null,
      apartment: null,
      policy: null,
      depositAmount: null,
    },
    landlordArray: null,
    apartmentArray: null,
    policyArray: null,
    error: null
  };
  
  export default initialState;
  